import React from 'react';
import type {AssignmentRuleExceptionsProps as SharedProps} from 'src/app/assignment-rules/AssignmentRuleExceptions';
import {AssignmentRuleExceptions as SharedAssignmentRuleExceptions} from 'src/app/assignment-rules/AssignmentRuleExceptions';
import {
  useAddCourseAssignmentRuleExceptionMutation,
  useListCourseAssignmentRuleExceptionsQuery,
  useRemoveCourseAssignmentRuleExceptionMutation,
} from 'src/redux/queries/courseAssignmentRule';

export type AssignmentRuleExceptionsProps = Pick<
  SharedProps,
  'ruleId' | 'canEdit'
>;

export const AssignmentRuleExceptions: React.FC<
  AssignmentRuleExceptionsProps
> = ({ruleId, canEdit}) => (
  <SharedAssignmentRuleExceptions
    ruleId={ruleId}
    canEdit={canEdit}
    matchedVerb="enrolled"
    useListExceptionsQuery={useListCourseAssignmentRuleExceptionsQuery}
    useAddExceptionMutation={useAddCourseAssignmentRuleExceptionMutation}
    useRemoveExceptionMutation={useRemoveCourseAssignmentRuleExceptionMutation}
  />
);
